<template>
  <div class="optionDate-content">
    <el-select v-model="selectValue" :placeholder="selectPlaceholder" @change="getSelect"
      class="optionDate-content_select">
      <el-option v-for="item in options" :key="item.value" :label="item[props.label]" :value="item[props.value]">
      </el-option>
    </el-select>
    <ybl-date-range v-model="dateValue" :type="type" :diff="diff" :unit="unit" value-format="yyyy-MM-dd"
      range-separator="—" @change="getDate" :beginPicker="beginPickerOptions" :endPicker="endPickerOptions"
      @beginFocusDate="beginFocusDate" @endFocusDate="endFocusDate" class="optionDate-content_date"></ybl-date-range>
  </div>
</template>
<script>
export default {
  name: 'yblOptionDate',
  model: {
    prop: 'date',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    date: {
      type: String | Array,
      default: () => ''
    },
    select: {
      type: String | Number,
      default: () => ''
    },
    props: {
      type: Object,
      default () {
        return { label: 'label', value: 'value' }
      }
    },
    diff: { // 起始日期和截止日期 间隔范围 （单位：天） 默认值 负数 表示不计算
      type: Number,
      default: () => -1
    },
    unit: { // 日期范围单位 （ d 天 M 月 y 年）
      type: String,
      default: () => 'd'
    },
    type: {
      type: String,
      default: () => 'date'
    },
    selectPlaceholder: {
      type: String,
      default: () => '请选择'
    },
    beginPickerOptions: {
      type: Object,
      default () {
        return null
      }
    },
    endPickerOptions: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      dateValue: [],
      selectValue: ''
    }
  },
  created () {
    console.log(this.endPickerOptions)
    this.dateValue = this.date
    this.selectValue = this.select
  },
  mounted () {
  },
  methods: {
    getSelect (e) {
      console.log(e)
      this.$emit('selectChange', e)
    },
    getDate (e) {
      this.$emit('change', e)
    },
    beginFocusDate () {
      this.$emit('beginFocusDate')
    },
    endFocusDate () {
      this.$emit('endFocusDate')
    }
  },
  watch: {
    'date': function (newVal, oldVal) {
      this.dateValue = newVal
    },
    'select': function (newVal, oldVal) {
      this.selectValue = newVal
    }
  }
}
</script>
<style lang="less" scoped>
.optionDate-content {
  display: flex;
  align-items: center;
  &_select {
    width: 95px;
    /deep/ .el-input {
      width: 95px;
      min-width: 95px;
      font-size: 12px;
      &.is-focus {
        .el-input__inner {
          border-color: #dcdfe6;
        }
      }
      .el-input__inner {
        width: 95px;
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        background-color: #f5f7fa;
        color: #999999;
        &:focus {
          border-color: #dcdfe6;
        }
      }
    }
  }
  &_date {
    height: 30px;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 2px !important;
    border-bottom-right-radius: 2px !important;
    /deep/ .el-input {
      font-size: 12px;
      height: 29px;
      line-height: 29px;
      .el-input__inner {
        height: 29px;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/optionDate.vue